import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Button } from 'primeng/button';
import BodyType from '../../../../../types/body-type/BodyType';
import BodyTypeWriteDTO from '../../../../../types/body-type/BodyTypeWriteDTO';
import { IsAdminDirective } from '../../../directives/is-admin.directive';
import { RoleNamePipe } from '../../../pipes/role-name.pipe';
import { BodyTypeService } from '../../../services/body-type.service';
import {
    UpdateBodyTypeDialogComponent
} from '../../shared/body-types/update-body-type-dialog/update-body-type-dialog.component';
import { PageHeaderComponent } from '../../shared/page-header/page-header.component';

@Component({
    selector: 'app-body-type-detail',
    templateUrl: './body-type-detail.component.html',
    styleUrls: [ './body-type-detail.component.scss' ],
    imports: [
        Button,
        RouterLink,
        PageHeaderComponent,
        UpdateBodyTypeDialogComponent,
        RoleNamePipe,
        IsAdminDirective
    ]
})
export class BodyTypeDetailComponent implements OnInit {
    public bodyType: BodyType | null = null;
    public editableBodyType: BodyTypeWriteDTO = new BodyTypeWriteDTO({});
    public displayUpdateDialog = false;

    constructor(
        private route: ActivatedRoute,
        private bodyTypeService: BodyTypeService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService
    ) {
    }

    /**
     * Initializes the component
     */
    public ngOnInit(): void {
        this.loadBodyType();
    }

    /**
     * Opens the edit dialog
     */
    public openEditDialog(): void {
        this.editableBodyType = new BodyTypeWriteDTO(this.bodyType ?? {});
        this.displayUpdateDialog = true;
    }

    /**
     * Reloads the body type details
     */
    public reloadBodyTypeDetails(): void {
        this.loadBodyType();
    }

    /**
     * Confirms the deletion of the body type
     */
    public confirmDelete(): void {
        if (!this.bodyType) {
            return;
        }

        this.confirmationService.confirm({
            message: `Are you sure you want to delete the body type '${ this.bodyType.name }'?`,
            header: 'Confirm Deletion',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                if (!this.bodyType) {
                    return;
                }
                this.bodyTypeService.deleteBodyType(this.bodyType.id).then(() => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Deleted',
                        detail: 'Body Type deleted successfully',
                        life: 3000
                    });
                    // Navigate back to the body types page
                    window.history.back();
                }).catch((error: any) => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
                });
            }
        });
    }

    /**
     * Loads the body type
     */
    private loadBodyType(): void {
        const id = this.route.snapshot.paramMap.get('id');
        if (id) {
            const idNumber = parseInt(id, 10);
            this.bodyTypeService.getBodyType(idNumber).then((result: BodyType) => {
                this.bodyType = result;
            }).catch((error: any) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
            });
        }
    }
}
